import { useRef } from "react";

export function useStore<T>(initializer: () => T) {
  const storeRef = useRef<T>(null);

  if (!storeRef.current) {
    storeRef.current = initializer();
  }

  return storeRef.current;
}
